// removed by extract-text-webpack-plugin
module.exports = {"answerBox":"SelectionButton__answerBox___3gRunum","container":"SelectionButton__container___3yDG2Vq"};